// extracted by mini-css-extract-plugin
export default {"toggle":"uqY3_Q","focus":"ea2g0G","input":"igaHti","label":"heirI4","track":"uE_H4R","knob":"ZSW0jd","icon":"DIFlja","iconTrue":"VqjktG","iconFalse":"U3BiVB"};